/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BorrowerContractualizationResponse } from './BorrowerContractualizationResponse';
import {
    instanceOfBorrowerContractualizationResponse,
    BorrowerContractualizationResponseFromJSON,
    BorrowerContractualizationResponseFromJSONTyped,
    BorrowerContractualizationResponseToJSON,
} from './BorrowerContractualizationResponse';
import type { ContractualizationResponseDto } from './ContractualizationResponseDto';
import {
    instanceOfContractualizationResponseDto,
    ContractualizationResponseDtoFromJSON,
    ContractualizationResponseDtoFromJSONTyped,
    ContractualizationResponseDtoToJSON,
} from './ContractualizationResponseDto';

/**
 * @type ContractualizationData
 * 
 * @export
 */
export type ContractualizationData = { type: 'CBNO' } & ContractualizationResponseDto | { type: 'CHO' } & ContractualizationResponseDto | { type: 'EMP' } & BorrowerContractualizationResponse | { type: 'GLI' } & ContractualizationResponseDto | { type: 'MRI' } & ContractualizationResponseDto | { type: 'PJ' } & ContractualizationResponseDto;

export function ContractualizationDataFromJSON(json: any): ContractualizationData {
    return ContractualizationDataFromJSONTyped(json, false);
}

export function ContractualizationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractualizationData {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'CBNO':
            return Object.assign({}, ContractualizationResponseDtoFromJSONTyped(json, true), { type: 'CBNO' } as const);
        case 'CHO':
            return Object.assign({}, ContractualizationResponseDtoFromJSONTyped(json, true), { type: 'CHO' } as const);
        case 'EMP':
            return Object.assign({}, BorrowerContractualizationResponseFromJSONTyped(json, true), { type: 'EMP' } as const);
        case 'GLI':
            return Object.assign({}, ContractualizationResponseDtoFromJSONTyped(json, true), { type: 'GLI' } as const);
        case 'MRI':
            return Object.assign({}, ContractualizationResponseDtoFromJSONTyped(json, true), { type: 'MRI' } as const);
        case 'PJ':
            return Object.assign({}, ContractualizationResponseDtoFromJSONTyped(json, true), { type: 'PJ' } as const);
        default:
            throw new Error(`No variant of ContractualizationData exists with 'type=${json['type']}'`);
    }
}

export function ContractualizationDataToJSON(json: any): any {
    return ContractualizationDataToJSONTyped(json, false);
}

export function ContractualizationDataToJSONTyped(value?: ContractualizationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'CBNO':
            return Object.assign({}, ContractualizationResponseDtoToJSON(value), { type: 'CBNO' } as const);
        case 'CHO':
            return Object.assign({}, ContractualizationResponseDtoToJSON(value), { type: 'CHO' } as const);
        case 'EMP':
            return Object.assign({}, BorrowerContractualizationResponseToJSON(value), { type: 'EMP' } as const);
        case 'GLI':
            return Object.assign({}, ContractualizationResponseDtoToJSON(value), { type: 'GLI' } as const);
        case 'MRI':
            return Object.assign({}, ContractualizationResponseDtoToJSON(value), { type: 'MRI' } as const);
        case 'PJ':
            return Object.assign({}, ContractualizationResponseDtoToJSON(value), { type: 'PJ' } as const);
        default:
            throw new Error(`No variant of ContractualizationData exists with 'type=${value['type']}'`);
    }

}

